import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';

const OurHistory = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    { labelKey: 'nav.aboutUs', href: '/#about-us' },
    { labelKey: 'aboutUs.ourHistory' }
  ];

  return (
    <PageTemplate 
      titleKey="pages.ourHistory.title"
      subtitleKey="pages.ourHistory.subtitle"
      breadcrumbs={breadcrumbs}
    >
      <div className="content-card">
        <h2>{t('pages.ourHistory.intro.title')}</h2>
        <p>{t('pages.ourHistory.intro.description')}</p>

        <div className="timeline" style={{ position: 'relative', padding: '40px 0' }}>
          <div className="timeline-item" style={{ marginBottom: '50px', paddingLeft: '60px', position: 'relative' }}>
            <div style={{ position: 'absolute', left: '0', top: '0', width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
              2004
            </div>
            <h3 style={{ color: '#667eea', marginBottom: '10px' }}>{t('pages.ourHistory.milestones.2004.title')}</h3>
            <p style={{ color: '#666' }}>{t('pages.ourHistory.milestones.2004.description')}</p>
          </div>

          <div className="timeline-item" style={{ marginBottom: '50px', paddingLeft: '60px', position: 'relative' }}>
            <div style={{ position: 'absolute', left: '0', top: '0', width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
              2008
            </div>
            <h3 style={{ color: '#667eea', marginBottom: '10px' }}>{t('pages.ourHistory.milestones.2008.title')}</h3>
            <p style={{ color: '#666' }}>{t('pages.ourHistory.milestones.2008.description')}</p>
          </div>

          <div className="timeline-item" style={{ marginBottom: '50px', paddingLeft: '60px', position: 'relative' }}>
            <div style={{ position: 'absolute', left: '0', top: '0', width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
              2012
            </div>
            <h3 style={{ color: '#667eea', marginBottom: '10px' }}>{t('pages.ourHistory.milestones.2012.title')}</h3>
            <p style={{ color: '#666' }}>{t('pages.ourHistory.milestones.2012.description')}</p>
          </div>

          <div className="timeline-item" style={{ marginBottom: '50px', paddingLeft: '60px', position: 'relative' }}>
            <div style={{ position: 'absolute', left: '0', top: '0', width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
              2016
            </div>
            <h3 style={{ color: '#667eea', marginBottom: '10px' }}>{t('pages.ourHistory.milestones.2016.title')}</h3>
            <p style={{ color: '#666' }}>{t('pages.ourHistory.milestones.2016.description')}</p>
          </div>

          <div className="timeline-item" style={{ marginBottom: '50px', paddingLeft: '60px', position: 'relative' }}>
            <div style={{ position: 'absolute', left: '0', top: '0', width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
              2020
            </div>
            <h3 style={{ color: '#667eea', marginBottom: '10px' }}>{t('pages.ourHistory.milestones.2020.title')}</h3>
            <p style={{ color: '#666' }}>{t('pages.ourHistory.milestones.2020.description')}</p>
          </div>

          <div className="timeline-item" style={{ paddingLeft: '60px', position: 'relative' }}>
            <div style={{ position: 'absolute', left: '0', top: '0', width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
              2024
            </div>
            <h3 style={{ color: '#667eea', marginBottom: '10px' }}>{t('pages.ourHistory.milestones.2024.title')}</h3>
            <p style={{ color: '#666' }}>{t('pages.ourHistory.milestones.2024.description')}</p>
          </div>
        </div>

        <div className="feature-box">
          <h4>{t('pages.ourHistory.future.title')}</h4>
          <p>{t('pages.ourHistory.future.description')}</p>
        </div>
      </div>
    </PageTemplate>
  );
};

export default OurHistory;
